import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22ad4104"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters-container" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "p-input-icon-left searchbar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = { class: "checkbox-container" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "checkbox-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Seniority", -1))
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "checkbox-container" }
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "checkbox-container" }
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "checkbox-container" }
const _hoisted_16 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_chevron_up = _resolveComponent("chevron-up")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          placeholder: "Buscar ofertas"
        }, null, 8, ["modelValue"])
      ])
    ], 512), [
      [_vShow, _ctx.hasFilters]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["item__wrapper", _ctx.isAreaOpen ? 'item__chevron--up' : 'item__chevron--down']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAreaOpen = !_ctx.isAreaOpen))
        }, [
          _createVNode(_component_icon, {
            size: 18,
            strokeColor: "#eaff6a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_chevron_up)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('job-offers.area')), 1),
        _withDirectives(_createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areas, (area) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-field-checkbox",
              key: area.value
            }, [
              _createVNode(_component_Checkbox, {
                class: "ch-checkbox",
                id: area.value,
                name: area.name,
                value: area.value,
                modelValue: _ctx.areasSelected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.areasSelected) = $event))
              }, null, 8, ["id", "name", "value", "modelValue"]),
              _createElementVNode("label", {
                class: "label-text",
                for: area.value
              }, _toDisplayString(area.name), 9, _hoisted_7)
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isAreaOpen]
        ])
      ], 512), [
        [_vShow, _ctx.areas.length > 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(["item__wrapper", _ctx.isHierarchyOpen ? 'item__chevron--up' : 'item__chevron--down']),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isHierarchyOpen = !_ctx.isHierarchyOpen))
        }, [
          _createVNode(_component_icon, {
            size: 18,
            strokeColor: "#eaff6a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_chevron_up)
            ]),
            _: 1
          })
        ], 2),
        _hoisted_9,
        _withDirectives(_createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hierarchies, (hierarchy) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-field-checkbox",
              key: hierarchy.value
            }, [
              _createVNode(_component_Checkbox, {
                class: "ch-checkbox",
                id: hierarchy.value,
                name: hierarchy.name,
                value: hierarchy.value,
                modelValue: _ctx.hierarchiesSelected,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hierarchiesSelected) = $event))
              }, null, 8, ["id", "name", "value", "modelValue"]),
              _createElementVNode("label", {
                class: "label-text",
                for: hierarchy.value
              }, _toDisplayString(hierarchy.name), 9, _hoisted_10)
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isHierarchyOpen]
        ])
      ], 512), [
        [_vShow, _ctx.hierarchies.length > 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["item__wrapper", _ctx.isModalityOpen ? 'item__chevron--up' : 'item__chevron--down']),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isModalityOpen = !_ctx.isModalityOpen))
        }, [
          _createVNode(_component_icon, {
            size: 18,
            strokeColor: "#eaff6a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_chevron_up)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('job-offers.modality')), 1),
        _withDirectives(_createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalities, (modality) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-field-checkbox",
              key: modality.value
            }, [
              _createVNode(_component_Checkbox, {
                class: "ch-checkbox",
                id: modality.value,
                name: modality.name,
                value: modality.value,
                modelValue: _ctx.modalitiesSelected,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalitiesSelected) = $event))
              }, null, 8, ["id", "name", "value", "modelValue"]),
              _createElementVNode("label", {
                class: "label-text",
                for: modality.value
              }, _toDisplayString(modality.name), 9, _hoisted_12)
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isModalityOpen]
        ])
      ], 512), [
        [_vShow, _ctx.modalities.length > 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(["item__wrapper", _ctx.isTypeOpen ? 'item__chevron--up' : 'item__chevron--down']),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isTypeOpen = !_ctx.isTypeOpen))
        }, [
          _createVNode(_component_icon, {
            size: 18,
            strokeColor: "#eaff6a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_chevron_up)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('job-offers.type')), 1),
        _withDirectives(_createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (t) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-field-checkbox",
              key: t.value
            }, [
              _createVNode(_component_Checkbox, {
                class: "ch-checkbox",
                id: t.value,
                name: t.name,
                value: t.value,
                modelValue: _ctx.typesSelected,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.typesSelected) = $event))
              }, null, 8, ["id", "name", "value", "modelValue"]),
              _createElementVNode("label", {
                class: "label-text",
                for: t.value
              }, _toDisplayString(t.name), 9, _hoisted_14)
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isTypeOpen]
        ])
      ], 512), [
        [_vShow, _ctx.types.length > 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: _normalizeClass(["item__wrapper", _ctx.isCountryOpen ? 'item__chevron--up' : 'item__chevron--down']),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isCountryOpen = !_ctx.isCountryOpen))
        }, [
          _createVNode(_component_icon, {
            size: 18,
            strokeColor: "#eaff6a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_chevron_up)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('job-offers.country')), 1),
        _withDirectives(_createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-field-checkbox",
              key: country.value
            }, [
              _createVNode(_component_Checkbox, {
                class: "ch-checkbox",
                id: country.value,
                name: country.name,
                value: country.value,
                modelValue: _ctx.countriesSelected,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.countriesSelected) = $event))
              }, null, 8, ["id", "name", "value", "modelValue"]),
              _createElementVNode("label", {
                class: "label-text",
                for: country.value
              }, _toDisplayString(country.name), 9, _hoisted_16)
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isCountryOpen]
        ])
      ], 512), [
        [_vShow, _ctx.countries.length > 1]
      ])
    ], 512), [
      [_vShow, _ctx.hasFilters]
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Button, {
        onClick: _ctx.clearFilters,
        class: "button button--clear-filters",
        label: "Borrar filtros"
      }, null, 8, ["onClick"])
    ])
  ]))
}